import React from 'react'

import * as S from './styled'

export type ArrowsProps = {
  size?: 'xsmall' | 'small' | 'medium'
  children: React.ReactNode
}

export const Arrows = ({ size = 'medium', children }: ArrowsProps) => (
  <S.Container $size={size}>{children}</S.Container>
)
